<template>
  <Card
    class="koc-default-collection-item-article"
    :image-link="FormattingService.formatUrl(item)"
    :image-url="state.imageUrl"
    :content-title="item.title"
    :content-link="FormattingService.formatUrl(item)"
    :content-body="`${state.truncateBody}...`"  
    footer-text="READ MORE"
    :footer-link="FormattingService.formatUrl(item)"     
  />
</template>

<script src="./article.js"></script>
<style lang="scss" scoped src="./article.scss"></style>